/**
 * Sticky "Pick your destination" CTA — shows once the visitor has scrolled
 * roughly one screen past the top (the hero/first section is out of view),
 * hides again near the top. Plain scroll-position trigger rather than an
 * IntersectionObserver on a specific section (unlike the product page's
 * .je-sticky-bar in je-product-hero.js) since this bar renders sitewide
 * across pages that don't all share one common "hero" element to watch.
 */
(function () {
  var bar = document.getElementById('JeDestStickyBar');
  if (!bar) return;

  var input = document.getElementById('JeStickyBarSearch');
  var ticking = false;

  function update() {
    // Tapping the search input opens the on-screen keyboard, which on
    // mobile Safari/Chrome scrolls the page slightly to bring the
    // focused field into view — that scroll fired this same handler,
    // and if it happened to land window.scrollY back under the
    // threshold, this bar (and the dropdown open inside it) hid itself
    // out from under the visitor mid-search. Skip the scroll-based
    // hide/show entirely while the input has focus; the bar only
    // re-evaluates once they've moved on from it.
    if (input && document.activeElement === input) {
      ticking = false;
      return;
    }
    var threshold = window.innerHeight * 0.6;
    bar.hidden = window.scrollY < threshold;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );

  update();
})();
